import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { handleResetIframe } from "../../../actions/headerMenu/headerMenu";
import { Spin, Tooltip } from "antd";
import config from "../../../helper/config";

const ApplicationPreviewGemStone = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("message", handleIframeTask);

    window.onpageshow = () => {
      dispatch(handleResetIframe(false));
    };
    const iframe = document.querySelector("iframe");
    iframe.contentWindow.postMessage("Show", "*");
  }, []);

  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [loading, setLoading] = useState(true);

  const handleIframeTask = (e) => {
    if (e.data === "submitted form") {
      document.getElementsByClassName("content__area")[0].scroll(0, 0);
    }
  };

  const src = `${config.GemstoneLinkURL}/Mined?DealerLink=${loginDetials.responseData.dealerId}&isChange=True`;
  const hideSpinner = () => {
    setLoading(false);
    document.getElementsByClassName("content__area")[0].scroll(0, 0);
    dispatch(handleResetIframe(false));
    const iframe = document.querySelector("iframe");
    iframe.contentWindow.postMessage("Show", "*");
  };

  return (
    <React.Fragment>
      <Spin spinning={loading}>
        <iframe
          id="ApplicationPreviewGemStone"
          onLoad={() => hideSpinner()}
          width="100%"
          className="application__preview"
          src={src}
        ></iframe>
      </Spin>
    </React.Fragment>
  );
};

export default ApplicationPreviewGemStone;
